import { render, staticRenderFns } from "./blood_pressure.vue?vue&type=template&id=74c5a071&scoped=true&"
import script from "./blood_pressure.vue?vue&type=script&lang=js&"
export * from "./blood_pressure.vue?vue&type=script&lang=js&"
import style0 from "./blood_pressure.vue?vue&type=style&index=0&id=74c5a071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c5a071",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74c5a071')) {
      api.createRecord('74c5a071', component.options)
    } else {
      api.reload('74c5a071', component.options)
    }
    module.hot.accept("./blood_pressure.vue?vue&type=template&id=74c5a071&scoped=true&", function () {
      api.rerender('74c5a071', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/pulse/blood_pressure.vue"
export default component.exports